// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__ohXWU","pageInner":"page_pageInner__3-JRZ","fullWidth":"page_fullWidth__3wdeV"};